import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UnreadMessageCountBridgeService {
  private unreadMessageCountSubject = new BehaviorSubject<number>(0);
  unreadMessageCount$ = this.unreadMessageCountSubject.asObservable();

  setUnreadMessageCount(count: number) {
    this.unreadMessageCountSubject.next(count);
  }
}